import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getRouteStopsPreview: build.query({
      query: body => ({
        url: '/api/v1/core/route/stops/preview',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useLazyGetRouteStopsPreviewQuery } = extendedApi
